import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import MenuItems from "../views/MenuItems.vue";
import MenuItemShow from "../components/MenuItemShow.vue";
import Cart from "../views/Cart.vue";
import Orders from "../views/Orders.vue";
import Login from "../views/Login.vue";
import SignUp from "../views/SignUp.vue";
import FavouriteItems from "../views/FavouriteItems.vue";
import Profile from "../views/Profile.vue";
import OrdersShow from "../components/OrderShow.vue";
import Deals from "../views/Deals.vue";
import DealShow from "../components/DealShow.vue";
import Cards from "../views/Cards.vue";
import { store } from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/menu_items",
    name: "menu_items",
    component: MenuItems
  },
  {
    path: "/menu_items/:id",
    component: MenuItemShow
  },
  {
    path: "/cart",
    name: "cart",
    component: Cart
  },
  {
    path: "/orders",
    name: "orders",
    component: Orders,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/orders/:id",
    component: OrdersShow,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    props: true,
    meta: {
      requiresVisitor: true
    }
  },
  {
    path: "/sign_up",
    name: "sign_up",
    component: SignUp,
    meta: {
      requiresVisitor: true
    }
  },
  {
    path: "/favourite_items",
    name: "favourite_items",
    component: FavouriteItems,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/deals",
    name: "deals",
    component: Deals
  },
  {
    path: "/deals/:id",
    component: DealShow
  },
  {
    path: "/cards",
    name: "card",
    component: Cards,
    meta: {
      requiresAuth: true
    }
  },
];

const router = new VueRouter({
  routes,
  mode:'history'
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.logged_in) {
      next({
        name: 'login'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.logged_in) {
      next({
        name: 'home'
      })
    } else {
      next()
    }
  }
   else {
    next()
  }
})

export default router;
